(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wall-of-love"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(grid) {
      if (!grid || grid.dataset.wolReady === '1') return;
      grid.dataset.wolReady = '1';

      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-wol-card]'));
      var initial = parseInt(grid.getAttribute('data-wol-initial'), 10) || 12;
      var batch = parseInt(grid.getAttribute('data-wol-batch'), 10) || 8;
      var moreWrap = grid.parentElement.querySelector('[data-wol-more]');
      var button = moreWrap ? moreWrap.querySelector('[data-wol-button]') : null;
      var visible = initial;

      function render() {
        cards.forEach(function(card, i) {
          if (i < visible) card.removeAttribute('hidden');
          else card.setAttribute('hidden', '');
        });
        if (moreWrap) {
          if (visible >= cards.length) moreWrap.setAttribute('hidden', '');
          else moreWrap.removeAttribute('hidden');
        }
      }

      render();

      if (button) {
        button.addEventListener('click', function() {
          visible = Math.min(visible + batch, cards.length);
          render();
        });
      }
    }

    document.querySelectorAll('[data-wol-grid]').forEach(init);

    document.addEventListener('shopify:section:load', function(e) {
      var grid = e.target.querySelector('[data-wol-grid]');
      if (grid) init(grid);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
